import React, { Component, Fragment } from 'react';
import { Map, List, fromJS } from 'immutable';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';

import styled, { ThemeProvider } from 'styled-components';
import { Flex, Box } from 'grid-styled';
import connect from '../store/connect';
import RadioButton from '../components/RadioButton';
import {
  fetchGlobalSearch,
  setViewstate,
  removeViewstate,
  removeGlobalSearch,
  removeQuickSearch
} from '../actions/actionCreators';
import Page from './Page';
import { color, size, animation } from '../styles/helpers/variables';
import { dynamicFontSize, fontFamilyHeading } from '../styles/helpers/mixins';
import { Heading } from '../styles/Heading';
import { Container } from '../styles/Container';
import { ProductImage } from '../styles/ProductImage';
import { NoProductsFound } from '../styles/NoProductsFound';
import ProductListWithFilters from '../components/ProductListWithFilters';
import PageList from '../components/PageList';
import { getProductsByList } from '../selectors/reselectCategory';
import { NavigationButton } from '../components/NavigationButton';
import MainProductImage from '../components/MainProductImage';
import { SITE_ROOT_URL } from '../constants/endpoints';
import { LoadingSpinner } from '../components/LoadingSpinner';
import History from '../history';

class SearchResultPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      activeSearchResults: '',
      highestRelevance: 0,
      hits: props.globalSearchResults.reduce((memo, item) => item.get('hits').size + memo, 0)
    };
    this.highestRelevanceInIndexHits = this.highestRelevanceInIndexHits.bind(this);
  }

  componentWillMount() {
    if (this.props.globalSearchQuery !== window.decodeURIComponent(this.props.match.params.searchQuery)) {
      this.props.removeGlobalSearch();
      this.props.fetchGlobalSearch(window.decodeURIComponent(this.props.match.params.searchQuery));
    }
  }

  componentDidMount() {
    this.highestRelevanceInIndexHits(this.props.globalSearchResults);
    this.props.removeQuickSearch();
  }

  componentWillReceiveProps(nextProps) {
    this.setState(() => ({
      hits: nextProps.globalSearchResults.reduce((memo, item) => item.get('hits').size + memo, 0)
    }));
    if (this.props.viewstate.get('currentCategory') !== nextProps.location.pathname) {
      this.props.setViewstate('currentCategory', nextProps.location.pathname);
      this.props.removeViewstate('filter');
      this.props.setViewstate('pagination', 0);
      this.props.setViewstate('sortAscending', true);
      this.props.setViewstate('sortBy', 'relevance');
    }

    if (this.props.globalSearchQuery !== nextProps.globalSearchQuery) {
      this.props.removeViewstate('filter');
      History.replace(`/sok/${window.encodeURIComponent(nextProps.globalSearchQuery)}`);
    }
    if (this.props.globalSearchResults !== nextProps.globalSearchResults) {
      this.props.removeQuickSearch();
      this.setState(() => ({
        activeSearchResults: '',
        highestRelevance: 0
      }));
      this.highestRelevanceInIndexHits(nextProps.globalSearchResults);
    }
  }

  changeSearchOption(event) {
    this.setState({ activeSearchResults: event.target.value });
  }

  highestRelevanceInIndexHits(globalSearchResults) {
    globalSearchResults.map((item, index) => {
      const first = item.get('hits', List()).first();
      const hits = item.get('hits', List());

      if (!item.isEmpty() && !hits.isEmpty()) {
        // TODO: this is a temp fix until backend can solve relevance properly
        const firstItemWithRelevanceBoost = first.get('id') ? first.get('relevance') + 10 : first.get('relevance');

        this.setState(prevState => ({
          highestRelevance:
            prevState.highestRelevance < firstItemWithRelevanceBoost
              ? firstItemWithRelevanceBoost
              : prevState.highestRelevance,
          activeSearchResults:
            prevState.highestRelevance < firstItemWithRelevanceBoost ? index : prevState.activeSearchResults
        }));
      }
      return true;
    });
  }
  renderSearchOptions() {
    return this.props.globalSearchResults
      .map((item, index) => {
        const isHitsEmpty = item.get('hits').isEmpty();
        let name = '';
        if (index === 'products' && !isHitsEmpty) name = 'Produkter';

        if (index === 'pages' && !isHitsEmpty) name = 'Sidor';

        if (index === 'categories' && !isHitsEmpty) name = 'Kategorier';

        if (index === 'designers' && !isHitsEmpty) name = 'Formgivare';

        if (index === 'brands' && !isHitsEmpty) name = 'Varumärken';

        if (!name) return false;

        return (
          <RadioButton
            theme="white"
            key={index}
            id={`search-option-${index}`}
            name="searchOptions"
            value={index}
            checked={this.state.activeSearchResults === index}
            onChange={e => {
              this.changeSearchOption(e);
            }}
          >
            <SearchOptionLabel>{name}</SearchOptionLabel>
          </RadioButton>
        );
      })
      .toArray();
  }

  renderSearchResults() {
    const brands = this.props.globalSearchResults
      .getIn(['brands', 'hits'], List())
      .map(item => (
        <Box
          key={item.getIn(['item', 'systemId'])}
          width={[1 / 2, 1 / 3, 1 / 4, 1 / 5, 1 / 6]}
          p={['4px', '6px', '8px', '12px']}
        >
          <ProductCardLink to={`${item.getIn(['item', 'url'])}`}>
            <ProductCardContainer>
              <MainProductImage insideList>
                {item.getIn(['item', 'images', 0, 'url']) ? (
                  <ProductImage src={SITE_ROOT_URL + item.getIn(['item', 'images', 0, 'url'])} />
                ) : (
                  false
                )}
              </MainProductImage>
              <NameTag>{item.getIn(['item', 'name'])}</NameTag>
            </ProductCardContainer>
          </ProductCardLink>
        </Box>
      ))
      .toArray();

    const designers = this.props.globalSearchResults
      .getIn(['designers', 'hits'], List())
      .map(item => (
        <Box
          key={item.getIn(['item', 'systemId'])}
          width={[1 / 2, 1 / 3, 1 / 4, 1 / 5]}
          p={['4px', '6px', '8px', '12px']}
        >
          <ProductCardLink to={`${item.getIn(['item', 'url'])}`}>
            <ProductCardContainer>
              <MainProductImage round insideList>
                {item.getIn(['item', 'images', 0, 'url']) ? (
                  <ProductImage round src={SITE_ROOT_URL + item.getIn(['item', 'images', 0, 'url'])} />
                ) : (
                  false
                )}
              </MainProductImage>
              <NameTag>{item.getIn(['item', 'name'])}</NameTag>
            </ProductCardContainer>
          </ProductCardLink>
        </Box>
      ))
      .toArray();

    if (this.props.globalSearchStatus === 'LOADING') {
      return (
        <Container>
          <LoadingSpinner />
        </Container>
      );
    }

    return (
      <Fragment>
        {this.state.activeSearchResults === 'products' ? (
          <ProductListWithFilters includeRelevance includeCategoryFilter allProducts={this.props.products} />
        ) : (
          false
        )}

        {this.state.activeSearchResults === 'pages' ? (
          <Container style={{ paddingTop: '0', paddingBottom: '2em' }}>
            <PageList
              pages={this.props.globalSearchResults.getIn(['pages', 'hits'], List())}
              searchQuery={this.props.globalSearchQuery}
            />
          </Container>
        ) : (
          false
        )}

        {this.state.activeSearchResults === 'brands' ? (
          <Container style={{ paddingTop: '0', paddingBottom: '2em' }}>
            <ThemeProvider
              theme={{
                breakpoints: ['40em', '53.125em', '68.75em', '99.625em']
              }}
            >
              <Flex flexWrap="wrap" ml={['-4px', '-6px', '-8px', '-12px']} mr={['-4px', '-6px', '-8px', '-12px']}>
                {brands}
              </Flex>
            </ThemeProvider>
          </Container>
        ) : (
          false
        )}

        {this.state.activeSearchResults === 'designers' ? (
          <Container style={{ paddingTop: '0', paddingBottom: '2em' }}>
            <Flex flexWrap="wrap" ml={['-4px', '-6px', '-8px', '-12px']} mr={['-4px', '-6px', '-8px', '-12px']}>
              {designers}
            </Flex>
          </Container>
        ) : (
          false
        )}

        {this.state.activeSearchResults === 'categories' ? (
          <Container style={{ paddingTop: '0', paddingBottom: '2em' }}>
            <ThemeProvider
              theme={{
                breakpoints: ['500px', '730px', '800px', '1200px']
              }}
            >
              <Flex flexWrap="wrap" mx={['0px', '-8px', '-11px']} my={30}>
                {this.props.globalSearchResults
                  .getIn(['categories', 'hits'], List())
                  .filter(category => category.hasIn(['item', 'url']))
                  .filter(category => category.getIn(['item', 'url']).split('/')[1] !== 'varumarke') // TODO: Remove this line once this is fixed on backend
                  .map(category => (
                    <Box
                      key={category.getIn(['item', 'systemId'])}
                      width={[1, 1, 1 / 2, 1 / 2, 1 / 3]}
                      py={['5px', '8px', '11px']}
                      px={['0px', '8px', '11px']}
                    >
                      <NavigationButton
                        title={category.getIn(['item', 'name'])}
                        url={category.getIn(['item', 'url'])}
                        image={category.getIn(['item', 'images', 0, 'url'], null)}
                      />
                    </Box>
                  ))}
              </Flex>
            </ThemeProvider>
          </Container>
        ) : (
          false
        )}
        {!this.state.activeSearchResults &&
          this.props.globalSearchResults.isEmpty() &&
          this.props.globalSearchStatus === 'SUCCESS' && (
            <Container style={{ paddingTop: '0', paddingBottom: '2em' }}>
              <NoProductsFound>Inga sökträffar</NoProductsFound>
            </Container>
          )}
      </Fragment>
    );
  }

  render() {
    const { globalSearchQuery } = this.props;
    const searchResults = this.renderSearchResults();
    const searchOptions = this.renderSearchOptions();

    const metaData = fromJS({
      title: `Sökresultat för “${globalSearchQuery}”`,
      metaTitle: `Sökresultat för “${globalSearchQuery}” | Vålamagasinet`,
      follow: false,
      index: false,
      metaDescription: ''
    });

    return (
      <Page
        meta={metaData}
        bgColor={color.lightGrey}
        lastBreadcrumbItem={{ title: 'Sök', url: this.props.location.pathname }}
      >
        <Container style={{ paddingTop: '1em', paddingBottom: '0' }}>
          <Heading big center>
            Sökresultat för “{globalSearchQuery}” {this.state.hits > 0 && `(${this.state.hits})`}
          </Heading>
        </Container>
        {this.state.activeSearchResults &&
          this.props.globalSearchStatus === 'SUCCESS' && (
            <Container style={{ paddingTop: '0', paddingBottom: '1em' }}>
              <SearchOptionsContainer>{searchOptions}</SearchOptionsContainer>
            </Container>
          )}
        {searchResults}
      </Page>
    );
  }
}

const NameTag = styled.p`
  background-color: ${color.white};
  line-height: 1.3;
  text-align: center;
  margin: 0;
  padding: 30px 5px;
  text-overflow: ellipsis;
  white-space: nowrap;
  overflow: hidden;
  ${fontFamilyHeading};

  ${dynamicFontSize(14, 18)};
  @media screen and (min-width: ${size.medium}px) {
    ${dynamicFontSize(18, 20)};
  }
  @media screen and (min-width: 850px) {
    font-size: 20px;
  }
`;

const ProductCardContainer = styled.div`
  background-color: #fff;
  margin: 0;
  padding: 0 0 10px;
  position: relative;

  &:after {
    content: '';
    transition: opacity 0.4s ${animation.easing};
    box-shadow: 0 4px 20px 0 rgba(0, 0, 0, 0.2);
    opacity: 0;
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
  }
`;
const ProductCardLink = styled(Link)`
  color: inherit;
  text-decoration: none;
  transition: opacity ${animation.transitionTime} ${animation.easing};

  &:hover {
    opacity: 0.8;
    ${ProductCardContainer}:after {
      opacity: 1;
    }
  }
`;

const SearchOptionsContainer = styled.div`
  max-width: 700px;
  margin: 0 auto;
  display: flex;
  justify-content: space-around;
  align-items: center;
  flex-direction: column;

  @media screen and (min-width: ${size.medium}px) {
    flex-direction: row;
  }
`;

const SearchOptionLabel = styled.span`
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.57;
  letter-spacing: normal;
  text-align: left;
  color: #000000;
  padding-left: 10px;
`;

SearchResultPage.defaultProps = {
  globalSearchResults: Map(),
  products: Map(),
  globalSearchQuery: null,
  globalSearchStatus: null,
  viewstate: Map()
};

SearchResultPage.propTypes = {
  fetchGlobalSearch: PropTypes.func.isRequired,
  removeGlobalSearch: PropTypes.func.isRequired,
  removeQuickSearch: PropTypes.func.isRequired,
  setViewstate: PropTypes.func.isRequired,
  removeViewstate: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  globalSearchResults: PropTypes.instanceOf(Map),
  globalSearchQuery: PropTypes.string,
  globalSearchStatus: PropTypes.string,
  products: PropTypes.instanceOf(Map),
  location: PropTypes.object.isRequired,
  viewstate: PropTypes.instanceOf(Map)
};

export default connect(
  SearchResultPage,
  { setViewstate, removeViewstate, fetchGlobalSearch, removeGlobalSearch, removeQuickSearch },
  store => {
    const searchResultProducts = getProductsByList(store);
    return {
      globalSearchResults: store.globalSearch.results,
      globalSearchQuery: store.globalSearch.query,
      globalSearchStatus: store.globalSearch.status,
      products: searchResultProducts,
      viewstate: store.viewstate
    };
  }
);



// WEBPACK FOOTER //
// ./src/pages/SearchResultPage.js